var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusSector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50174 16.3414C12.8325 16.3414 16.3433 12.8306 16.3433 8.49978C16.3433 4.169 12.8325 0.658203 8.50174 0.658203C4.17095 0.658203 0.660156 4.169 0.660156 8.49978C0.660156 12.8306 4.17095 16.3414 8.50174 16.3414Z",
    fill: "#1756E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C3.81348 17 0 13.1872 0 8.5C0 3.81348 3.81348 0 8.5 0C13.1872 0 17 3.81348 17 8.5C17 13.1872 13.1872 17 8.5 17ZM8.5 1.3168C4.53903 1.3168 1.3168 4.53903 1.3168 8.5C1.3168 12.461 4.53903 15.6832 8.5 15.6832C12.461 15.6832 15.6832 12.4603 15.6832 8.5C15.6832 4.53903 12.461 1.3168 8.5 1.3168Z",
    fill: "#1756E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50217 12.3911C8.13873 12.3911 7.84375 12.0968 7.84375 11.7327V5.14865C7.84375 4.78521 8.13873 4.49023 8.50217 4.49023C8.86561 4.49023 9.16059 4.78521 9.16059 5.14865V11.7327C9.16059 12.0968 8.86561 12.3911 8.50217 12.3911Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7932 9.09881H5.2092C4.84576 9.09881 4.55078 8.80384 4.55078 8.4404C4.55078 8.07696 4.84576 7.78198 5.2092 7.78198H11.7932C12.1574 7.78198 12.4517 8.07696 12.4517 8.4404C12.4517 8.80384 12.1574 9.09881 11.7932 9.09881Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusSector);
export default __webpack_public_path__ + "static/media/iconPlusSector.87c0d33aae1a942d7899aa167e56539b.svg";
export { ForwardRef as ReactComponent };